import * as React from 'react';
import { useTranslate } from 'react-admin';

import CardWithIcon from './CardWithIcon';
import Transform from '@material-ui/icons/Transform';

interface Props {
	value?: number;
}

const TotalCoachesCreatedCard = (props: Props) => {
	const { value } = props;
	const translate = useTranslate();
	return (
		<CardWithIcon
			to={{
				pathname: '/coaches',
				search: `filter=${JSON.stringify({ from_becameACoach: (new Date(2022, 1, 1)).toISOString() })}`
			}}
			icon={Transform}
			title={translate('TOTAL_COACHES_CREATED')}
			subtitle={value || '---'}
		/>
	);
};

export default TotalCoachesCreatedCard;
